<template>
  <div class="tile is-parent">
    <article class="tile is-child box">
      <div class="info-wrap block">
        <div>
          <image-component v-if="params.avatar && params.avatar.image" class="avatar" :image="params.avatar" :width="100" :compress="1.2"></image-component>
          <span v-else="" class="avatar-empty">暂无头像</span>
        </div>
        <div class="info">
          <p class="title">{{params.accountName}}</p>avatar-empty
          <p>{{params.brief}}</p>
        </div>
        <div class="margin-top1">
          <button v-if="params.status" class="button is-danger" @click="subscribeClick">取消订阅</button>
          <button v-else="" class="button is-success" @click="subscribeClick">订阅</button>
        </div>
      </div>
      <div>
        <p class="title">ID:{{params.accountId}}</p>
        <p>设置筛选条件</p>
        <p class="block">可以只抓取包含特定词语的{{name}}</p>
        <div class="block">
          <p class="title">抓取关键词</p>
          <input type="text" class="input width-3" v-model="inputKeywords">
          <button class="button is-success" @click="addTag('keywords')">添加</button>
        </div>
        <div class="block">
          <template v-for="(item,index) in params.keywords">
            <a v-if="item != ''" class="tags button is-primary is-outlined" @click="deleteTag('keywords',item,index)">
              <span>{{item}}</span>
              <span class="icon">
              <i class="fa fa-times"></i>
            </span>
            </a>
          </template>
        </div>
        <div class="block">
          <p class="title">屏蔽关键词</p>
          <input type="text" class="input width-3" v-model="inputExcludeKeywords">
          <button class="button is-success margin-right2" @click="addTag('excludeKeywords')">添加</button>
        </div>
        <div class="block">
          <template v-for="(item,index) in params.excludeKeywords">
            <a v-if="item!=''" class="tags button is-primary is-outlined" @click="deleteTag('excludeKeywords',item)">
              <span>{{item}}</span>
              <span class="icon">
              <i class="fa fa-times"></i>
            </span>
            </a>
          </template>
        </div>
        <div class="margin-top1">
          <button class="button is-info margin-right2" @click="saveSource">确认修改</button>
          <button class="button" @click="backClick">返回</button>
        </div>
      </div>
    </article>
  </div>
</template>
<script type="text/babel">
  export default{
    data(){
      return{
        name:"",//分类名
        inputKeywords:"",
        inputExcludeKeywords:"",
        acccountId:0,
        type:0,//订阅类型
        params:{
          type:0,
          avatar:{},
          accountId:0,
          accountName:"",
          accountKey:"",
          brief:"",
          keywords:[],
          excludeKeywords:[]
        }
      }
    },
    mounted(){
      this.name = this.$route.query.name;
      this.accountId = this.$route.query.accountId;
      this.type = this.$route.query.type;
      this.getSource();
    },
    methods:{
      /**
       * 删除关键词
       * */
      deleteTag(type,value,index){
        this.params[type].splice(index,1);
      },
      /**
       * 添加关键词
       * */
      addTag(type){
        if(type == "keywords"){
          if(this.params[type].indexOf(this.inputKeywords) > -1){
            this.$message("该关键词已经存在,不能重复添加");
          }else{
            this.params[type].push(this.inputKeywords)
          }
          this.inputKeywords = "";
        }else{
          if(this.params[type].indexOf(this.inputExcludeKeywords) > -1){
            this.$message("该关键词已经存在,不能重复添加");
          }else{
            this.params[type].push(this.inputExcludeKeywords)
          }
          this.inputExcludeKeywords = "";
        }
      },
      /**
       * 获取内容源信息
       * */
      getSource(){
        HttpRequest.get('/admin.php?method=fashion.getSource', {accountId:this.accountId}).then((response) => {
          this.params = Object.assign({},response.data);
        })
      },
      /**
       * 保存内容源修改
       * */
      saveSource(){
        if(this.inputKeywords || this.inputExcludeKeywords){
          if(confirm("还有未添加的关键词,真的不要带着一起保存吗?")){
            this.saveSourcePost()
          }
        }else{
          this.saveSourcePost()
        }

      },
      saveSourcePost(){
        HttpRequest.post('/admin.php?method=fashion.doSaveSource', this.params).then((response) => {
          if(response.data.success){
          this.$message("编辑成功~")
          setTimeout(()=>{
            this.$router.push({
              name: 'subscripeSource',
              query: {
                type: this.type,
                page: this.$route.query.page,
                accountName: this.$route.query.accountName,
                activeIndex: this.$route.query.activeIndex,
              }
            })
        },2000)
        }
      })
      },
      /**
       * 取消订阅
       * */
      subscribeClick(){
        let status = 0;
        if(this.params.status == 0){
          status = 1
        }
        let params = {
          accountId:this.params.accountId,
          status:status
        }
        let mesg = "确定要取消订阅吗?";
        if(this.params.status == 0){
          mesg = "确定要重新订阅吗?"
        }
        if(confirm(mesg)){
          HttpRequest.get('/admin.php?method=fashion.setSourceStatus', params).then((response) => {
            if(response.data.success){
              if(status == 0){
                this.$message("取消成功~");
                this.params.status = 0;
              }else{
                this.$message("订阅成功~");
                this.params.status = 1;
              }
              setTimeout(()=>{
                this.$router.push({
                  name:"subscripeSource",
                  query:{
                    type:this.type
                  }
                });
              },2000)
            }
          })
        }
      },
      /**
       * 返回
       * */
      backClick(){
        this.$router.push({
          name: 'subscripeSource',
          query: {
            type: this.type,
            page: this.$route.query.page,
            accountName: this.$route.query.accountName,
            activeIndex: this.$route.query.activeIndex,
          }
        })
      }
    }
  }
</script>
<style lang="less" spcoed>
  .info-wrap{
    display:flex;
    .avatar{
      width: 80px;
      height: 80px;
      display: inline-block;
      border-radius: 40px;
    }
    .info{
      margin: 10px 40px 0 20px;
    }
  }
  .margin-top1{
    margin-top: 10px;
  }
  .margin-right2{
    margin-right: 10px;
  }
  .tags{
    margin-right: 10px;
  }
  .avatar-empty{
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
    color: #000;
    font-size: 16px;
    border-radius: 40px;
    background: #ccc;
    display: inline-block;
  }
</style>
